import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'
import styles from './CaseDownloadCTA.module.scss'

export type CaseDownloadCTAItem = {
  title: string
  description: string | JSX.Element
  imageSrc: string
  href: string
}

export type CaseDownloadCTAProps = CaseDownloadCTAItem

const CaseDownloadCTA: React.FC<CaseDownloadCTAProps> = ({ title, description, imageSrc, href }) => {
  const animeRef = useRef<HTMLElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.caseDownloadCTA} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.caseDownloadCTA__inner}>
        <div className={styles.caseDownloadCTA__layout}>
          <div className={styles.caseDownloadCTA__spacer} aria-hidden="true" />
          <div className={styles.caseDownloadCTA__body}>
            <a href={href} className={styles.caseDownloadCTA__card}>
              <div className={styles.caseDownloadCTA__content}>
                <div className={styles.caseDownloadCTA__text}>
                  <p className={styles.caseDownloadCTA__title}>{title}</p>
                  <p className={styles.caseDownloadCTA__description}>{description}</p>
                </div>
                <span className={styles.caseDownloadCTA__button}>資料ダウンロード</span>
              </div>
              <div className={styles.caseDownloadCTA__imageWrap}>
                <img src={imageSrc} alt={title} className={styles.caseDownloadCTA__image} />
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CaseDownloadCTA
